import { name } from './constants';
import reducer from './reducer';
import VacationApprovals from './VacationApprovals';

export default {
  name,
  VacationApprovals,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/vacationApprovals/index.js